// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__5OcOq","disabled":"styles_disabled__c9Gkd"};